// extracted by mini-css-extract-plugin
export var buttons = "_bm-0";
export var buttonsActive = "_bm-h";
export var cancelConfirm = "_bm-1";
export var closeButton = "_bm-2";
export var column = "_bm-3";
export var container = "_bm-4";
export var detailHeader = "_bm-6";
export var detailTitle = "_bm-7";
export var detailsContent = "_bm-5";
export var header = "_bm-8";
export var headerWithClose = "_bm-9";
export var icon = "_bm-a";
export var infoIcon = "_bm-c";
export var informationContainer = "_bm-b";
export var sideDrawer = "_bm-d";
export var sideDrawerOpen = "_bm-e";
export var stickyFooter = "_bm-f";
export var typeOption = "_bm-g";